module.exports = __webpack_public_path__ + "static/media/party-popper.c4f6b74d.svg";